import VueCompositionApi, { reactive, ref } from "@vue/composition-api";
import _axios from "@/axios";
import { showSnackBar } from "@/composables/snackbar";
import { handleFormErrors } from "@/composables/form-error";
import Vue from "vue";

Vue.use(VueCompositionApi);

const cards = ref([]);
export function useCard() {
  const cardData = reactive({
    card: null,
    cardForm: {
      cardModel: 1,
      mode: 1,
      restrictionType: 1,
    },
    attributes: [],
    createCardDialog: false,
    editCardDialog: false,
    rules: {
      idRules: [
        (v) =>
          (!!v && v.length >= 6 && v.length <= 10) ||
          "L'identifiant doit faire entre 6 et 10 caractères",
      ],
      passwordRules: [
        (v) =>
          (!!v && v.length >= 6) ||
          "Le mot de passe doit faire plus de 6 caractères",
      ],
      cardModelRules: [],
      modeRules: [],
      restrictionTypeRules: [],
    },
    cardFormRef: null,
    modesChoice: [
      { text: "BASIC Card", value: 0 },
      { text: "FULL Card", value: 1 },
    ],
    restrictionTypesChoice: [
      { text: "Portal Only", value: 1 },
      { text: "Portal and Clients from the same Group", value: 2 },
      { text: "None", value: 3 },
    ],
    isLoading: false,
  });

  function listCards(clientId = null) {
    let routePath = "";
    if (clientId != null) {
      routePath = "/list-card/portal/" + clientId;
    }
    return _axios
      .get(routePath)
      .then((response) => {
        cards.value = response.data.data;
      })
      .catch(() => {
        alert(
          "Une erreur est survenue, si cela se reproduit contactez le support"
        );
      });
  }

  function searchCard(id) {
    return _axios
      .get("/card/" + id)
      .then((response) => {
        cardData.card = response.data.data;
      })
      .catch(() => {});
  }

  function showCard(id) {
    return _axios
      .get("/card/" + id)
      .then((response) => {
        cardData.card = response.data.data;
      })
      .catch(() => {
        alert(
          "Une erreur est survenue, si cela se reproduit contactez le support"
        );
      });
  }

  function showCardAttribute(id) {
    return _axios
      .get("/card-attribute/" + id)
      .then((response) => {
        cardData.attributes = response.data.data;
      })
      .catch(() => {
        alert(
          "Une erreur est survenue, si cela se reproduit contactez le support"
        );
      });
  }

  function createCard(clientId = null) {
    cardData.isLoading = true;
    cardData.cardForm.client = clientId;
    cardData.createCardDialog = true;

    if (cardData.cardFormRef != null) {
      const isValid = cardData.cardFormRef.validate();
      if (!isValid) {
        cardData.isLoading = false;
        return;
      }
    }

    return _axios
      .post("/create-card", cardData.cardForm)
      .then(() => {
        listCards(clientId);
        showSnackBar();
        cardData.createCardDialog = false;
      })
      .catch((error) => {
        const formErrors = error.response.data.violations;
        handleFormErrors(formErrors, cardData.rules, cardData.cardFormRef);
      })
      .finally(() => {
        cardData.isLoading = false;
      });
  }

  function updateCard(cardId = null) {
    cardData.isLoading = true;
    cardData.editCardDialog = true;

    if (cardData.cardFormRef != null) {
      const isValid = cardData.cardFormRef.validate();
      if (!isValid) {
        cardData.isLoading = false;
        return;
      }
    }
    if (cardData.cardForm.maxConnectionDuration == "") {
      cardData.cardForm.maxConnectionDuration = null;
    }
    if (cardData.cardForm.maxUsageDuration == "") {
      cardData.cardForm.maxUsageDuration = null;
    }

    return _axios
      .put("/card/" + cardId, cardData.cardForm)
      .then((response) => {
        cardData.card = response.data.data;
        showSnackBar();
        cardData.editCardDialog = false;
      })
      .catch((error) => {
        const formErrors = error.response.data.violations;
        handleFormErrors(formErrors, cardData.rules, cardData.cardFormRef);
      })
      .finally(() => {
        cardData.isLoading = false;
      });
  }

  return {
    cardData,
    cards,
    listCards,
    showCard,
    createCard,
    showCardAttribute,
    searchCard,
    updateCard,
  };
}
